$('#employer').on('change keyup', function() {
    const $this = $(this),
        $error = $this.parents('.field').find('.field__error');

    // if no value, exit early and reset error text
    if (! $this.val()) {
        $error.text('');
        return;
    }

    // target datalist options
    const $options = $this.siblings('datalist').find('option');
    // fetch option values
    const options = $options.map((index, element) => $(element).val()).get();
    // check if current value is in options array
    if (options.includes($this.val())) {
        $error.text('').hide();
    } else {
        const text = $error.data('message') ? $error.data('message') : $this.prop('title');
        $error.text(text).show();
    }
});